import { render, staticRenderFns } from "./LunchWeek.vue?vue&type=template&id=b0b66e98&"
import script from "./LunchWeek.vue?vue&type=script&lang=js&"
export * from "./LunchWeek.vue?vue&type=script&lang=js&"
import style0 from "./LunchWeek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports